import { render, staticRenderFns } from "./SkeletonOCDetailComponentGlobal.vue?vue&type=template&id=0a675e54&scoped=true&"
import script from "./SkeletonOCDetailComponentGlobal.vue?vue&type=script&lang=js&"
export * from "./SkeletonOCDetailComponentGlobal.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonOCDetailComponentGlobal.vue?vue&type=style&index=0&id=0a675e54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a675e54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDivider,VRow,VSkeletonLoader,VSpacer})
